const APP_PREFIX = 'uofglife_'

/**
 * returns mappedGuid preferentially, otherwise guid
 */
export function getUserGuid () {
  const mappedGuid = getValue('mappedGuid')
  if (typeof mappedGuid === 'undefined' || mappedGuid === '' || mappedGuid == null) {
    return getValue('guid')
  } else {
    return mappedGuid
  }
}

export function hasKey (keyName) {
  if (window.localStorage) {
    const keys = Object.keys(window.localStorage)
    return keys.indexOf(APP_PREFIX + keyName) != -1
  } else {
    console.error('local storage not available!')
    return false
  }
}
export function getValue (name) {
  if (window.localStorage) {
    const item = window.localStorage.getItem(APP_PREFIX + name)
    if (typeof item !== 'undefined') {
      const lookupKeyName = APP_PREFIX + name
      let val = window.localStorage.getItem(lookupKeyName)
      // console.log('getValue("' + name + '") => ' + val)
      if (typeof val !== 'undefined' && val != 'undefined') {
        try {
          val = JSON.parse(val)
        } catch (e) {
          console.error(e)
        }
      } else if (val == 'undefined') {
        console.log('key "' + lookupKeyName + '" returned "undefined"!')
      }

      return val
    } else {
      console.log('item for ' + name + ' is not defined :-(')
      return ''
    }
  } else {
    console.error('local storage is not available :-(')
  }
}

export function getAll () {
  let ret = {}
  if (window.localStorage) {
    let ls = window.localStorage
    const keys = Object.keys(ls)
    console.log('local storage contains ' + keys.length + ' keys')
    for (const k of keys) {
      if (k.startsWith(APP_PREFIX)) {
        const fetchName = k.substring(APP_PREFIX.length)
        // console.log('debug: looking up key ' + fetchName)
        ret[fetchName] = getValue(fetchName)
      } else {
        console.log('ignoring non-app key ' + k)
      }
    }
  } else {
    console.error('local storage is not available :-(')
  }
  return ret
}

export function setValue (name, value) {
  if (window.localStorage) {
    // don't store undefined
    if (typeof value !== 'undefined') {
      window.localStorage.setItem(APP_PREFIX + name, JSON.stringify(value))
    } else {
      console.log('ignoring request to store undefined')
    }
  } else {
    console.error('local storage is not available :-(')
  }
}

export function setValues (hash) {
  for (let x in hash) {
    setValue(x, hash[x])
  }
}

export function clearAllLocalStorage() {
  // this actually calls .clear()
  if (window.localStorage) {
    localStorage.clear()
    console.log('cleared all local storage')
  }
}
export function clearAll () {
  if (window.localStorage) {
    let ls = window.localStorage
    for (let k of Object.keys(ls)) {
      if (k.startsWith(APP_PREFIX)) {
        // console.log('clearing ' + k)
        ls.removeItem(k)
      }
    }
    // window.localStorage.clear()
  } else {
    console.error('local storage is not available :-(')
  }
}

export function deleteValue (keyName) {
  if (window.localStorage) {
    const lookupKeyName = APP_PREFIX + keyName
    window.localStorage.removeItem(lookupKeyName)
  } else {
    console.error('local storage is not available :-(')
  }
}
